<template lang="pug">
toggle-button(:value="hide_flag", @change="toggleAllCreative($event, url_token)", :labels="true", :disabled="disable")
</template>

<script>
import axios from 'axios'

export default {
  props: {
    popup_class: String,
    popup_id: Number,
    hide_flag: Boolean,
    url_token: String,
    disable: Boolean
  },
  methods: {
    async toggleAllCreative(e, url_token){
      await this.$store.dispatch("report/toggleAllCreativeDisplay", { url_token: url_token })
      if(e.value){
        this.$toasted.success('配信をONにしました')
        await sleep(10000)
        this.$toasted.clear()
      } else {
        this.$toasted.success('配信をOFFにしました')
        await sleep(10000)
        this.$toasted.clear()
      }
    }
  }
}
</script>
  